export const SCHEDULER_QUERY_ACTION_PARAM = {
    NAME: 'action',
    VALUES: {
        CREATE_POST: 'create_post'
    }
};
